export const BRAND_NAME = "Yardzen for Pros";

export const COLORS = {
  background: "#0a0a0a",
  nature: {
    green: "#626e58",
    gold: "#f4e5c2",
    lightGreen: "#d7e585",
  },
  surfaces: {
    dark: "#1f1f1f",
    darker: "#0f0f0f",
  },
};

export const UI_CONSTANTS = {
  sidebarWidth: 320,
  navbarHeight: 64,
  mobileBreakpoint: 768,
};

export const FLOW_STEPS = [
  { path: "address", label: "Project Setup" },
  { path: "features", label: "Yard Features" },
  { path: "style", label: "Select Style" },
  { path: "generating", label: "AI Generation" },
] as const;

export type FlowStepPath = (typeof FLOW_STEPS)[number]["path"];
